import React,{ Component } from 'react';
// import Link from 'react-router-dom/NavLink';

import {
  Nav,
  Container,
  Row,
  Col,
  Button,
  Card
} from 'reactstrap';

import find from 'lodash/find';

import ActiveBrandsDropDown from './ActiveBrandsDropDown';
import CampaignStats from './CampaignStats';
import CampaignList from './CampaignList';
import PlaceholderCampaignList from './PlaceholderCampaignList';
import Link from 'react-router-dom/NavLink'
// import Button from '../../../shared/components/Button';
import Pills from '../../../shared/components/Pills';

import { formatStatus, daysSinceEpoch,firstNonZeroOrOne } from '../../../shared/utils';

class Campaigns extends Component {
  constructor(){
    super();

    this.state = {
      brandFilter:[],
      status:'all',
      sortColumn:null,
      sortDescending:true
    };
  }


  getFilteredSortedCampaigns(){
    const { campaignKPIs, campaigns } = this.props;

    const { sortColumn, sortDescending, brandFilter } = this.state;

    const statusesInOrder = ['draft','pendingAgency','pendingAdjoy','ready','active','suspended','outOfFunds','complete'];

    const sortedFiltedCampaigns = campaigns
      .filter((campaign) => {
        const filterIsEmpty = brandFilter.length === 0,
          filterContainsBrand = brandFilter.indexOf(campaign.companyId) >= 0;

        return filterIsEmpty || filterContainsBrand;
      })
      .filter((campaign) => {
        const filterIsAll = this.state.status === 'all',
          filterIsPending = this.state.status === 'pending',
          filterIsComplete = this.state.status === 'complete',
          campaignIsPending = campaign.status === 'pendingAdjoy' || campaign.status === 'pendingAgency',
          campaignIsComplete = campaign.status === 'complete' || campaign.status === 'outOfFunds',
          isMatch = this.state.status === campaign.status;

        return filterIsAll || (filterIsPending && campaignIsPending) || (filterIsComplete && campaignIsComplete) || isMatch;
      })
      .sort((a,b) => {
        const nameAlphabeticalCompare =  (a.name || 'Untitled Experience').localeCompare((b.name || 'Untitled Experience')),
          statusAlphabeticalCompare = formatStatus(a.status).localeCompare(formatStatus(b.status)),
          statusOrderCompare = statusesInOrder.indexOf(a.status) - statusesInOrder.indexOf(b.status),
          launchCompare = daysSinceEpoch(a.launchDate) - daysSinceEpoch(b.launchDate),
          budgetCompare = parseFloat(a.lifetimeBudget || 0) - parseFloat(b.lifetimeBudget || 0),
          aKPI = find(campaignKPIs, (c) => c.campaignId === a.id) || {totalCompletions:-1, averageRating:-1},
          bKPI = find(campaignKPIs, (c) => c.campaignId === b.id) || {totalCompletions:-1, averageRating:-1},
          completionsCompare = aKPI.totalCompletions - bKPI.totalCompletions,
          ratingCompare = aKPI.averageRating - bKPI.averageRating;

        if(!sortColumn){
          return firstNonZeroOrOne([statusOrderCompare,launchCompare,nameAlphabeticalCompare]);

        } else if(sortColumn === 'experience'){
          return firstNonZeroOrOne([nameAlphabeticalCompare,launchCompare]);

        } else if(sortColumn === 'status'){
          return firstNonZeroOrOne([statusAlphabeticalCompare,launchCompare,nameAlphabeticalCompare]);

        } else if(sortColumn === 'budget'){
          return firstNonZeroOrOne([budgetCompare,launchCompare,nameAlphabeticalCompare]);

        } else if(sortColumn === 'completions'){
          return firstNonZeroOrOne([completionsCompare,launchCompare,nameAlphabeticalCompare]);

        } else if(sortColumn === 'rating'){
          return firstNonZeroOrOne([ratingCompare,launchCompare,nameAlphabeticalCompare]);

        } else {
          return firstNonZeroOrOne([statusOrderCompare,launchCompare,nameAlphabeticalCompare]);
        }
      });

      return sortDescending ? sortedFiltedCampaigns : sortedFiltedCampaigns.reverse() ;
  }

  getMatchingCampaignKPIs(){
    const { brandFilter } = this.state,
      { campaignKPIs } = this.props;

    return campaignKPIs.filter((kpi) => brandFilter.length === 0 || brandFilter.indexOf(kpi.brandId) >= 0);
  }

  getMatchingBrandKPIs(){
    const { brandFilter } = this.state,
      { brandKPIs } = this.props;

    return brandKPIs.filter((kpi) => brandFilter.length === 0 || brandFilter.indexOf(kpi.brandId) >= 0);
  }

  getPlaceholderBrands(){
    return [
      {name:'Brand 1',id:'__SOME_FAKE_BRAND'},
      {name:'Brand 2',id:'__ANOTHER_FAKE_BRAND__'}
    ];
  }

  getEmptyTextForCampaignList(){
    const statusFilter = this.state.status,
      campaigns = this.props.campaigns;

    if(statusFilter === 'all' || campaigns.length === 0) return 'No experiences yet, create one to get started!';
    if(statusFilter === 'draft') return 'No drafted experiences';
    if(statusFilter === 'pending') return 'No pending experiences';
    if(statusFilter === 'ready') return 'None of your experiences are ready for launch';
    if(statusFilter === 'active') return 'None of your experiences are active yet';
    if(statusFilter === 'suspended') return 'None of your experiences are currently paused';
    if(statusFilter === 'complete') return 'None of your experiences have finished yet';
  }

  handleRevertClick(campaignId){
    this.props.revertCampaignToDraft(campaignId);
    this.props.history.push(`${this.props.match.url}/create/${campaignId}`);
  }

  render(){
    const {
      brands,
      match,
      campaignKPIs,
      user,
      deleteCampaign,
      suspendCampaign,
      resumeCampaign,
      // revertCampaignToDraft,
      duplicateCampaign,
      shouldForceOpenBrandPicker,
      shouldUsePlaceholderDataForStats,
      shouldUsePlaceholderDataForList,
      shouldGrayOutStats
    } = this.props;

    return (
      <div className='Campaigns'>
        <div className='BlueBackground'>
          <Container>
            <Row>
              <Col xs='12'>
                <br />
                <Nav className='sort-brands'>
                  <ActiveBrandsDropDown
                    isForcedOpen={shouldForceOpenBrandPicker}
                    brands={shouldUsePlaceholderDataForList ? this.getPlaceholderBrands() : brands}
                    defaultFilter={this.state.brandFilter}
                    onFilterChange={(filter) => this.setState({brandFilter:filter})}
                  />
                </Nav>
              </Col>
            </Row>
            <Row>
              <Col xs='12'>
                <CampaignStats
                  isGreyedOut={shouldGrayOutStats}
                  isUsingPlaceholderData={shouldUsePlaceholderDataForStats}
                  campaignKPIs={this.getMatchingCampaignKPIs()}
                  brandKPIs={this.getMatchingBrandKPIs()}
                />
                <br />
              </Col>
            </Row>
          </Container>
        </div>
        <div className='GrayBackground'>
          <Container>
            <Card>
              <Container style={{padding:'1.5rem'}}>
                <Row>
                  <Col xs='8'>
                    <Pills
                      selected={this.state.status}
                      onChange={(status) => this.setState({status:status})}
                      states={['all','draft','pending','ready','active','suspended','complete']}
                      titles={['All','Draft','Pending','Ready','Active','Paused','Completed']}
                    />
                  </Col>
                  <Col xs='4'>
                    <Button
                      className='float-right CreateCampaignButton'
                      to={`${match.url}/create/new`}
                      tag={Link}
                      color='primary'
                    >
                      Create Experience
                    </Button>
                  </Col>
                </Row>
              </Container>
              {shouldUsePlaceholderDataForList ? (
                <PlaceholderCampaignList />
              ) : (
                <CampaignList
                  emptyText={this.getEmptyTextForCampaignList()}
                  currentUrl={match.url}
                  campaigns={this.getFilteredSortedCampaigns()}
                  campaignKPIs={campaignKPIs}
                  brands={brands}
                  userIsOwner={user.isOwner}
                  onDeleteClick={(campaignId) => deleteCampaign(campaignId)}
                  onSuspendClick={(campaignId) => suspendCampaign(campaignId)}
                  onResumeClick={(campaignId) => resumeCampaign(campaignId)}
                  onRevertClick={(campaignId) => this.handleRevertClick(campaignId)}
                  onDuplicateClick={(campaignId) => duplicateCampaign(campaignId)}
                  onSort={(sortColumn,sortDescending) => this.setState({sortColumn:sortColumn,sortDescending:sortDescending})}
                />
                )}
              </Card>
              <br />
              <br />
              <br />
          </Container>
        </div>
      </div>
    )
  }
}

export default Campaigns;



// WEBPACK FOOTER //
// ./src/routes/AgencyCampaignsDashboard/components/AgencyCampaignsDashboard.js